<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Admin Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <label>Name</label>
      <v-text-field
        v-model.trim="admin.name"
        :error-messages="handleFieldErrors($v.admin.name)"
        type="text"
        outlined
        dense
      ></v-text-field>

      <label>Email Address</label>
      <v-text-field
        v-model.trim="admin.email"
        :error-messages="handleFieldErrors($v.admin.email)"
        type="text"
        outlined
        dense
      ></v-text-field>
      <label>Roles</label>
      <v-combobox
        v-model="admin.role"
        :error-messages="handleFieldErrors($v.admin.role)"
        outlined
        dense
        item-text="name"
        item-value="id"
        :items="roles"
      ></v-combobox>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn v-if="admin.id" @click="emitAdminData" class="form-btn">
        Update
      </v-btn>
      <v-btn v-else @click.prevent="emitAdminData" class="form-btn">
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";

export default {
  mixins: [ValidationMixin],
  props: {
    admin: {
      type: Object,
      default: () => {
        return {
          name: null,
          email: null,
          role: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    admin: {
      name: {
        required,
      },
      email: {
        required,
        email,
        minLength: minLength(4),
      },
      role: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Admin", ["roles"]),
  },
  watch: {
    admin() {
      if (this.admin.role) {
        this.admin.role = this.roles.find((item) => {
          return item.id == this.admin.role;
        });
      }
    },
  },
  methods: {
    emitAdminData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.admin.name,
          email: this.admin.email,
          role: this.admin.role.id,
        };

        this.admin.id ? (data.id = this.admin.id) : false;

        this.$emit("emitAdminData", data);

        this.admin.email = null;
        this.admin.name = null;
        this.admin.role = null;
        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
